module.exports = __webpack_public_path__ + "static/media/19.2843f180.jpg";